import React from 'react';

function Footer() {
  return <footer><p>Copyright &copy; 2024 WorkerScan</p></footer>;
}

export default Footer;
